export default __webpack_public_path__ + "static/media/gyroY.7859b886.svg";